import { useState, useEffect } from 'react';
import { useSortable } from "@dnd-kit/sortable";

const FlowBuilderSortableStage = ({ stage, id, i, currentFlowStages, selectedStageIndex, setSelectedStageIndex, stageDepArray, flowStageTypes, allTypeformForms, allCustomForms }) => {
  const [stageType, setStageType] = useState('')
  const [stageDeps, setStageDeps] = useState([])
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({
    id,
  });

  const style = {
    transform: transform
      ? `translate(${transform.x}px, ${transform.y}px)`
      : undefined,
    transition: isDragging ? 'none' : transition,
    opacity: isDragging ? 0.5 : 1,
  };

  const handleSelectStage = (i) => {
    setSelectedStageIndex(i)
  }

  useEffect(() => {
    if (stage && stage.flowStageTypeId) {
      const newStageType = flowStageTypes.find((type) => type.id === stage.flowStageTypeId)
      setStageType(newStageType)
    }
  }, [flowStageTypes, stage.flowStageTypeId])

  useEffect(() => {
    if (!stageType) return

    const newStageDeps = stageType.dependencies.map((dep, i) => {
      const depFormArray = []
      if (dep === 'typeform') {
        if (Array.isArray(stage.dependencyIdentifiers[i])) {
          for (const depId of stage.dependencyIdentifiers[i]) {
            const depForm = allTypeformForms?.find((form) => form.formId === depId)
            depFormArray.push(depForm?.formTitle)
          }
        } else {
          const depForm = allTypeformForms?.find((form) => form.formId === stage.dependencyIdentifiers[i])
          depFormArray.push(depForm?.formTitle)
        }

      } else if (dep === 'customForm') {
        if (Array.isArray(stage.dependencyIdentifiers[i])) {
          for (const depId of stage.dependencyIdentifiers[i]) {
            const depForm = allCustomForms?.find((form) => form.id === depId)
            depFormArray.push(depForm?.formTitle)
          }
        } else {
          const depForm = allCustomForms?.find((form) => form.id === stage.dependencyIdentifiers[i])
          depFormArray.push(depForm?.formTitle)
        }
      }

      return [dep, depFormArray]
    })

    setStageDeps(newStageDeps)
  }, [stageType, stage?.dependencyIdentifiers, allTypeformForms, allCustomForms])

  return (
    <div
      key={id}
      onMouseDown={() => handleSelectStage(i)}
      className={`flex bg-white shadow-md rounded-md px-6 py-4 w-fit min-w-[50%] text-center cursor-pointer transition border-2 ${currentFlowStages[selectedStageIndex]?.id === stage.id ? 'border-blue-500' : 'border-transparent'}`}
      ref={setNodeRef}
      {...attributes}
      {...listeners}
      style={style}
    >
      <div className='flex flex-col text-sm items-start gap-1'>
        <p>{i + 1}.</p>

        <div className='flex border rounded px-1'>
          <p>Title: {stage?.title}</p>
        </div>

        <div className='flex border rounded px-1'>
          <p>Type: {stageType?.name}</p>
        </div>

        <div className='flex gap-4 border rounded px-1'>
          <p>Dependencies: </p>
          <div className='flex flex-col '>
            {stageDeps?.map((dep, i) => {
              return (
                <div key={`dep${i}`} className={`flex gap-2 ${stageDeps.length - 1 === i ? '' : 'border-b'}`}>
                  <p>{dep[0]}:</p>
                  <div className='flex flex-col items-start'>
                    {dep[1]?.map((form, index) => <p key={`form${index}`}>{form}</p>)}
                  </div>
                </div>
              )
            })}
          </div>
        </div>


      </div>
    </div>

  );
};

export default FlowBuilderSortableStage;